import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
	{
		path: `${process.env.VUE_APP_DIRECTORY}/`,
		redirect: `${process.env.VUE_APP_DIRECTORY}/home`,
		meta: {
			guest: true,
			title: "Chemformation Admin",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/admin-login`,
		name: "Login",
		component: () => import("@/views/Public/Login.vue"),
		meta: {
			guest: true,
			title: "Chemformation - Login",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/home`,
		name: "Home",
		component: () => import("@/views/Private/Home.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Admin",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/product-admin`,
		name: "Product Maintenance",
		component: () => import("@/views/Private/ProductAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Product Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/product-inquiry`,
		name: "Product Inquiry",
		component: () => import("@/views/Private/ProductInquiry.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Product Inquiry",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/glossary-admin`,
		name: "Glossary Maintenance",
		component: () => import("@/views/Private/GlossaryAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Glossary Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/faq-admin`,
		name: "FAQ Maintenance",
		component: () => import("@/views/Private/FaqAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - FAQ Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/vendor-admin`,
		name: "Vendor Maintenance",
		component: () => import("@/views/Private/VendorAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Vendor Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/user-admin`,
		name: "User Maintenance",
		component: () => import("@/views/Private/UserAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - User Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/file-storage`,
		beforeEnter() {
			window.open("https://www.dropbox.com/home/Chemformation", "_blank");
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/system-message`,
		name: "System Message",
		component: () => import("@/views/Private/SystemMessage.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - System Message",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/cross-reference`,
		name: "Cross References",
		component: () => import("@/views/Private/CrossReferences.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Cross References",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/cross-reference-preview`,
		name: "Cross Reference Preview",
		component: () => import("@/views/Private/CrossReferencePreview.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Cross References",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/report`,
		redirect: `${process.env.VUE_APP_DIRECTORY}/reports/dashboard`,
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports`,
		redirect: `${process.env.VUE_APP_DIRECTORY}/reports/dashboard`,
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports/dashboard`,
		name: "Reports Dashboard",
		component: () => import("@/views/Private/Reports/Dashboard.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Reports Dashboard",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports/potential-products`,
		name: "Potential Products Report",
		component: () => import("@/views/Private/Reports/PotentialProducts.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Potential Products",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports/search-activity`,
		name: "Search Activity Report",
		component: () => import("@/views/Private/Reports/SearchActivity.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Search Activity",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports/visit-report`,
		name: "Visit Report",
		component: () => import("@/views/Private/Reports/VisitReport.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Visit Report",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/reports/vendor-report`,
		name: "Vendor Report",
		component: () => import("@/views/Private/Reports/VendorReport.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Vendor Report",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/rate-limit-settings`,
		name: "Rate Limit Settings",
		component: () => import("@/views/Private/RateLimitSettings.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - Rate Limit Settings",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/api-keys`,
		name: "API Key Management",
		component: () => import("@/views/Private/ApiKeyAdmin.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - API Key Management",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/api-exclusions`,
		name: "API Exclusions",
		component: () => import("@/views/Private/ApiExclusions.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - API Exclusions",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/api-usage-log`,
		name: "API Usage Log",
		component: () => import("@/views/Private/ApiUsageLog.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - API Usage Log",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/mcp-usage`,
		name: "MCP Usage",
		component: () => import("@/views/Private/McpUsage.vue"),
		meta: {
			requiresAuth: true,
			title: "Chemformation - MCP Usage",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/company-admin`,
		name: "Company Admin",
		component: () => import("@/views/Private/CompanyAdmin.vue"),
		meta: {
			requiresAuth: true,
			requiresAdmin: true,
			title: "Chemformation - Company Maintenance",
		},
	},
	{
		path: `${process.env.VUE_APP_DIRECTORY}/ai-assistant`,
		name: "AI Assistant",
		component: () => import("@/views/Private/AiAssistant.vue"),
		meta: {
			requiresAuth: true,
			requiresAdmin: true,
			title: "Chemformation - AI Assistant",
		},
	},
	{
		// The page's first address; kept so bookmarks keep working.
		path: `${process.env.VUE_APP_DIRECTORY}/assistant-activity`,
		redirect: `${process.env.VUE_APP_DIRECTORY}/ai-assistant`,
	},
];

const router = new VueRouter({
	mode: "history",
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	base: process.env.BASE_URL,
	routes,
});

//redirects user if trying to access a page that requires login
router.beforeEach(async (to, from, next) => {
	await store.dispatch("verifySession").then(() => {
		if (to.matched.some((record) => record.meta.requiresAuth)) {
			if (store.getters.isLoggedIn) {
				next();
				return;
			} else {
				next(`${process.env.VUE_APP_DIRECTORY}/admin-login`);
			}
		} else {
			next();
			return;
		}
	});
});

router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.meta.title;
	});
});

export default router;
